import React from "react";
import s from "./Default.module.css"
import {useEffect, useState} from "react";
import axios from "axios";
import ToNews from "../News/ToNews";
import img from "../../assets/News/News260624.jpg"

const News260624 = ({children, header}) => {
    const [newsData, setNews] = useState([])

    return <div className={s.page}>
        <h2 style={{
            fontWeight: "normal",
            marginTop: "50px",
            color: "#3a4663",
            textAlign: "left",
            maxWidth: "1100px",
            margin: "40px auto",
            fontFamily: "Proxima Nova Lt"
        }}>
            Вебинар для ответственных секретарей комиссий по делам несовершеннолетних и защите их прав, а также
            специалистов, обеспечивающих деятельность комиссий по делам несовершеннолетних и защите их прав
        </h2>
        <div>
            <img src={img}/>
        </div>
        <div style={{fontFamily: "Proxima Nova Lt"}}>
            23 мая 2024 г. ФГБУ «Центр защиты прав и интересов детей» совместно с ФГБОУ ВО «Саратовская государственная
            юридическая академия» был организован вебинар по актуальным вопросам, возникающим в деятельности комиссий по
            делам несовершеннолетних и защите их прав при рассмотрении дел об административных правонарушениях.
            <p></p>
            В работе мероприятия в дистанционном формате приняли участие более 2 тысяч человек из 53 субъектов
            Российской Федерации, в том числе представители КДН и ЗП субъектов Российской Федерации
            и территориальных (муниципальных) комиссий.
            <p></p>
            В рамках вебинара обсуждались вопросы, касающиеся правоприменительной деятельности комиссий при рассмотрении
            дел
            об административных правонарушениях, включая вопросы применения административной ответственности за
            правонарушения, посягающие
            на права и законные интересы несовершеннолетних, а также производства
            по делам об административных правонарушениях в отношении несовершеннолетних.
            <p></p>
            <strong><a href="https://fcprc.ru/media/media/behavior/Программа_вебинара_LTQn7oU.pdf">Программа вебинара</a></strong>
            <p></p>
        </div>
        <ToNews/>
    </div>
}


export default News260624;